import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import OptionsTable, { OptionsTableHandle } from './OptionsTable'
import { useSpecialityOptions } from '../model/useSpecialityOptions'

export type SpecialityOptionData = {
  id: string
  code: string
  name: string
  selectByDefault?: boolean
}

export type SpecialityOptionsHandle = OptionsTableHandle

export function SpecialityOptions() {
  const { t } = useTranslation()
  const specialityOptions = useSpecialityOptions()

  const fields = useMemo(
    () =>
      [
        { id: 'code', isMandatory: true, name: t('field.code.label', { context: 'unique' }), prefix: 'speciality', type: 'string' },
        { id: 'name', isMandatory: true, name: t('field.name.label'), type: 'string' },
        { id: 'selectByDefault', align: 'center', isMandatory: false, name: t('field.selectByDefault.label'), type: 'boolean' },
      ] as const,
    [t]
  )

  return (
    <OptionsTable
      ref={specialityOptions.ref}
      data={specialityOptions.data}
      isCreating={specialityOptions.isCreating}
      isDeleting={specialityOptions.isDeleting}
      isListing={specialityOptions.isListing}
      isUpdating={specialityOptions.isUpdating}
      onCreate={specialityOptions.onCreate}
      onDelete={specialityOptions.onDelete}
      onSearch={specialityOptions.onSearch}
      onUpdate={specialityOptions.onUpdate}
      fields={fields}
      name="specialityOption"
    />
  )
}
